module.exports = __webpack_public_path__ + "41ed697115bd27a4979ce749ad2ddfc6.pdf";